import { useEffect } from 'react';
import { io } from 'socket.io-client';

interface DoorNotificationData {
    storeId?: string | number;
    kioskId?: string | number;
    storeLabel?: string;
    timestamp?: string;
    [key: string]: unknown;
}

export const useOpenDoorNotifications = (onDoorOpen?: (data: DoorNotificationData) => void) => {
    useEffect(() => {
        const url = import.meta.env.VITE_BACKEND_API_ENDPOINT || 'http://localhost:3333';

        const socket = io(url, {
            transports: ['websocket', 'polling'],
            autoConnect: true,
            timeout: 60000,
            reconnection: true,
            reconnectionDelay: 2000,
            reconnectionDelayMax: 10000,
            reconnectionAttempts: 10,
            forceNew: false,
            upgrade: true,
            rememberUpgrade: true,
        });

        socket.on('connect_error', (error) => {
            console.error('❌ [WebSocket] Connection error:', error);
        });

        socket.on('reconnect_error', (error) => {
            console.error('❌ [WebSocket] Reconnection failed:', error);
        });

        socket.on('door-open', (data: DoorNotificationData) => {
            if (onDoorOpen) {
                onDoorOpen(data);
            }
        });

        return () => {
            socket.disconnect();
        };
    }, [onDoorOpen]);
};
